import { dateTimeSqlToDateTimeBR } from './date'

const createdUpdatedUser = (userName, date) => {
  return userName ? `${userName} em ${dateTimeSqlToDateTimeBR(date)}` : '-'
}

const optionsTranslate = (value) => {
  const option = parseInt(value, 10)

  const map = {
    0: { label: 'Não', class: 'bg-danger' },
    1: { label: 'Sim', class: 'bg-success' },
  }

  const { label, class: css } = map[option] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

const statusTranslate = (value) => {
  const status = parseInt(value, 10)

  const map = {
    0: { label: 'Inativo', class: 'bg-danger' },
    1: { label: 'Ativo', class: 'bg-success' },
  }

  const { label, class: css } = map[status] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

const statusFaturamentoLabel = (value) => {
  const status = parseInt(value, 10)

  const map = {
    0: { label: 'Erro' },
    1: { label: 'Aguardando' },
    2: { label: 'Conferido' },
    3: { label: 'Movimento Criado' },
    4: { label: 'Faturado' },
  }

  return map[status].label || 'Indefinido'
}

const statusFaturamentoTranslate = (value) => {
  const status = parseInt(value, 10)

  const map = {
    0: { label: 'Erro', class: 'bg-danger' },
    1: { label: 'Aguardando', class: 'bg-yellow' },
    2: { label: 'Conferido', class: 'bg-secondary' },
    3: { label: 'Movimento Criado', class: 'bg-indigo' },
    4: { label: 'Faturado', class: 'bg-success' },
    10: { label: 'Processando ...', class: 'bg-teal' },
  }

  const { label, class: css } = map[status] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

const funcaoContatoLabel = (value) => {
  const status = parseInt(value, 10)

  const map = {
    1: { label: 'Recebe NF' },
    2: { label: 'Recebe Relatório' },
    3: { label: 'Recebe NF/Relatório' },
    4: { label: 'Usuário Chave' },
    5: { label: 'Gestor de Contrato' },
  }

  return map[status].label || 'Indefinido'
}

const tipoEmailLabel = (value) => {
  const status = parseInt(value, 10)

  const map = {
    1: { label: 'Envio de NF' },
    2: { label: 'Envio de Relatório' },
    3: { label: 'Envio de NF/Relatório' },
  }

  return map[status].label || 'Indefinido'
}

const statusNotificacaoFranquiaTranslate = (value) => {
  const status = parseInt(value, 10)

  const map = {
    0: { label: 'Erro', class: 'bg-danger' },
    1: { label: 'Enviado', class: 'bg-success' },
    2: { label: 'Superado', class: 'bg-secondary' },
  }

  const { label, class: css } = map[status] || {
    label: 'Indefinido',
    class: 'bg-secondary',
  }

  return `<span class="badge ${css}">${label}</span>`
}

const moneyToCurrencyBr = (value) => {
  if (value !== null && value !== '') {
    const money = parseFloat(value)
    return money.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  }
  return value
}

const formatPercent = (value) => {
  if (value !== null && value !== '') {
    return Number(value).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }
  return value
}

export {
  createdUpdatedUser,
  optionsTranslate,
  statusTranslate,
  statusFaturamentoLabel,
  statusFaturamentoTranslate,
  funcaoContatoLabel,
  tipoEmailLabel,
  statusNotificacaoFranquiaTranslate,
  moneyToCurrencyBr,
  formatPercent,
}
